import { useUpgradeModalStore } from "@/stores/upgrade-modal-store";

export function useUpgradeModal() {
	const { isOpen, title, message, context, workspaceId, reviewLimit, userRole, openUpgradeModal, closeUpgradeModal, maybeLater } = useUpgradeModalStore();

	return {
		isOpen,
		title,
		message,
		context,
		workspaceId,
		reviewLimit,
		userRole,
		openUpgradeModal,
		closeUpgradeModal,
		maybeLater,
	};
}

export function useOpenUpgradeModal() {
	const openUpgradeModal = useUpgradeModalStore((state) => state.openUpgradeModal);

	return openUpgradeModal;
}
